module.exports = __webpack_public_path__ + "static/media/image_placeholder.294de88d.jpg";